import { Box, Flex, Text } from "../../../components";
import { useGetActiveFacilities } from "../hooks/useGetActiveFacilities";
import dayjs from "dayjs";
import FacilityDetail from "./FacilityDetail";

const FacilityList = () => {
  const { data } = useGetActiveFacilities();
  const facilities = (data && data.data) || [];
  return (
    <>
      <Flex flexDirection="column" style={{ gap: "40px" }}>
        {facilities.map((item, index) => (
          <FacilityDetail
            id={item.id}
            key={index}
            name={item.name}
            roomSize={item.room_size}
            startDate={item.working_time_start_date}
            endDate={item.working_time_end_date}
            pricePerHour={item.price_per_hour}
            desc={item.desc}
            imageUrls={item.image_url}
          />
        ))}
      </Flex>
    </>
  );
};

export default FacilityList;
